module.exports = __webpack_public_path__ + "static/media/geogames_lookup.ba353858.png";